import { useId } from 'react';
import { FormattedMessage } from 'react-intl';
import { MeasureComparison, Interpretation } from 'components/MeasureComparison';
import { MeasureFormat } from 'components/measure-unit/MeasureFormat';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { trackMatomoEvent } from 'services/matomo.service';
import { Tile } from 'components/Layout/PageContainer';

export interface PriceKPICardProps {
  titleId: string;
  value: number;
  unit: MeasureUnitCode;
  delta?: number;
  subtextId?: string;
  hidePill?: boolean;
  interpretation?: number;
  testid?: string;
}

export function PriceKPICard({
  titleId,
  value,
  unit,
  delta = 0,
  subtextId = '',
  hidePill = false,
  interpretation = Interpretation.POSITIVE,
  testid = '',
}: PriceKPICardProps) {
  const instanceId = useId();

  const handleAttemptClick = () => {
    trackMatomoEvent({
      action: 'NonClickablePriceKPICard',
      name: {
        defaultNamePrefix: 'kpi-section',
        details: [titleId],
        testid,
        instanceId,
      },
      includePageContextInAction: true,
    });
  };

  const mockCurrentValue = 100 + (delta ?? 0);
  const mockComparisonValue = 100;

  return (
    <Tile className="h-full xl:col-span-4 col-span-3 justify-end gap-2.5" onClickCapture={handleAttemptClick}>
      <span className="font-bold text-lg flex-1">
        <FormattedMessage id={titleId} />
      </span>

      <MeasureFormat className="text-3xl font-bold" value={value} unit={unit} config={{ decimalPlaces: 2 }} />

      <div className="flex items-center justify-between  gap-2 ">
        <span className={!hidePill && delta !== undefined ? 'visible' : 'invisible'}>
          <MeasureComparison
            value={mockCurrentValue}
            comparisonValue={mockComparisonValue}
            unit={MeasureUnitCode.QUANTITY}
            interpretation={interpretation}
          />
        </span>
        {subtextId && (
          <span className="text-xs ">
            <FormattedMessage id={subtextId} />
          </span>
        )}
      </div>
    </Tile>
  );
}
